import { AttachmentPreviewMethod } from 'owa-attachment-data';
import { ClientAttachmentId } from 'owa-client-ids';
import GetAttachmentTextPreviewReadMode from 'owa-service/lib/contract/GetAttachmentTextPreviewReadMode';
import PreviewPaneSelectionSource from './PreviewPaneSelectionSource';

export enum SaveToCloudStatus {
    disabled,
    available,
    saving,
    succeeded,
    failed,
}

interface SxSExtendedViewState {
    previewMode: AttachmentPreviewMethod;
    attachmentId: ClientAttachmentId;
    selectionSource: PreviewPaneSelectionSource;
    isCloudy: boolean;
    saveToCloudStatus: SaveToCloudStatus;
    textPreviewReadMode: GetAttachmentTextPreviewReadMode;
}

export default SxSExtendedViewState;
